// Shared editor types and NZ date conversion. Database RPCs are the only assignment authority.
export const kinds = ['PACK_IN', 'RUN', 'PACK_OUT'] as const;
export type Kind = typeof kinds[number];
export type Mode = 'STAFFED' | 'UNATTENDED' | 'CLIENT' | 'COURIER' | 'NOT_REQUIRED';
export type Member = {
    id: string;
    staffId: string;
    name: string;
    duty: string;
    confirmation: 'PENDING' | 'ACCEPTED' | 'CONFIRMED' | 'DECLINED';
    startsAt?: string;
    endsAt?: string;
    hours?: number;
    fee?: number;
};
export type Phase = {
    id: string;
    shiftId: string;
    kind: Kind;
    mode: Mode;
    startsAt: string;
    endsAt: string;
    location: string;
    instructions: string;
    members: Member[];
    completion: 'PLANNED' | 'IN_PROGRESS' | 'COMPLETE';
    handover: string;
};
export function nzLocal(iso: string): string { if (!iso)
    return ''; const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Pacific/Auckland', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(iso)); const get = (k: string) => p.find(x => x.type === k)?.value; return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`; }
// NZ DST gap/fold times require explicit offset resolution, never silently guessed.
export function fromNZ(local: string): string { if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(local))
    throw Error('Enter a complete NZ date and time'); const utc = Date.parse(local + 'Z'); const matches = [12, 13].map(h => new Date(utc - h * 3600000).toISOString()).filter(v => nzLocal(v) === local); if (matches.length !== 1)
    throw Error(matches.length ? 'Ambiguous NZ daylight-saving time: choose a time outside the repeated hour' : 'Invalid NZ daylight-saving date/time'); return matches[0]; }
